import { FakturaStatus } from "./faktura-status.model";

export interface Faktura {
    afdeling: number;
    afdelingtekst: string;
    beloeb: number;
    bemaerkning: string;
    dokumentnr: number;
    dokumenttype: number;
    dokumenttypetekst: string;
    dokumentUrler?: string[];
    enheder: number;
    fakturadato: Date;
    fakturanr: string;
    filtype: number;
    fordeler: string;
    forfaldsdato: Date;
    godkendere: string;
    konteringstekst: string;
    konteringstekst2: string;
    konteringstekst3: string;
    kreditornavn: string;
    kreditornr: number;
    modpost: number;
    pdfLoadError?: string;
    projekt: number;
    projekttekst: string;
    rekvisitionsnr: string;
    status: FakturaStatus;
}
